import MetaMenu from '../../all/MetaMenu'
export default MetaMenu